module.exports = __webpack_public_path__ + "d224fd169b9a920dc8fcb0f4765714b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/qualcomm_2022_chart.png
// module id = 1727
// module chunks = 0